const phoneTypes = ["Cell", "Home"];

export default phoneTypes;
